import TrackingNumber from './trackingNumber';

export default TrackingNumber;
